// The app uses BrowserRouter, which has no useBlocker. The draft editor tells this module when it
// holds changes that are not saved, and the Warranty sidebar links ask before they leave. Other
// menus are not guarded.
let unsaved = false;

export const setUnsavedChanges = (value) => {
  unsaved = value === true;
};

export const hasUnsavedChanges = () => unsaved;

export const LEAVE_MESSAGE =
  "You have changes that are not saved yet. Leave this page and lose them?";

// True when the person may leave: nothing unsaved, or they confirmed.
export const confirmLeave = () => {
  if (!unsaved) {
    return true;
  }
  const leave = window.confirm(LEAVE_MESSAGE);
  if (leave) {
    unsaved = false;
  }
  return leave;
};
